import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { SYNC_TIMERS_FOR_SCENES } from '@app/constants/scenes/timers/timersForScenes'
import { setTimers, syncTimerChannel } from '@app/actions/timers/timers'
import timersForScenes from '@app/api/scenes/timers/timersForScenes'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'

const fetchTimersForScenes = createLogic({
  type: SYNC_TIMERS_FOR_SCENES,
  cancelType: API_REQUEST_CANCEL,

  transform({ getState, action }, next) {
    const { secrets: { accessToken: { token: accessToken } } } = getState()
    next({
      ...action,
      accessToken,
    })
  },

  process({ action }, dispatch, done) {
    dispatch(apiRequestSent(SYNC_TIMERS_FOR_SCENES))
    timersForScenes(action.accessToken)
      .then((response) => {
        const { data } = response
        dispatch(setTimers(data.timers))
        dispatch(apiRequestDone(SYNC_TIMERS_FOR_SCENES))
        dispatch(syncTimerChannel())
      })
      .catch((error) => {
        if (error) {
          const currentError = handleErrors(error)
          dispatch(apiRequestFailed(currentError))
        } else {
          throw new Error('timersForScenes failed without error')
        }
      })
      .then(() => done())
  },
})

export default fetchTimersForScenes
